import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, ArrowUpRight, Phone, ShieldCheck } from "lucide-react";
import { BUSINESS } from "../data/site";

export const Stripes = ({ className = "h-3 w-10", animate = false, delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={`inline-flex gap-[3px] ${className}`} aria-hidden="true">
      {["bg-blue", "bg-flame", "bg-brick"].map((c, i) => (
        <motion.span key={c} className={`h-full flex-1 origin-bottom ${c}`}
          initial={animate && !reduce ? { scaleY: 0 } : false} animate={{ scaleY: 1 }}
          transition={{ duration: 0.7, delay: delay + i * 0.1, ease: [0.22, 1, 0.36, 1] }} />
      ))}
    </span>
  );
};

export const CtaPair = ({ dark = true, testPrefix = "cta", bookLabel = "Book Your Free Assessment" }) => (
  <div className="flex flex-col gap-3 sm:flex-row">
    <Link to="/book" className="btn-primary group" data-testid={`${testPrefix}-book-btn`}>
      {bookLabel} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
    </Link>
    <a href={BUSINESS.phoneHref} className={dark ? "btn-ghost-dark" : "btn-ghost-light"} data-testid={`${testPrefix}-call-btn`}>
      <Phone className="h-4 w-4" /> Call {BUSINESS.phone}
    </a>
  </div>
);

export const ProofChip = ({ dark = true }) => (
  <p className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-semibold ${dark ? "border-white/15 bg-white/5 text-slate-200" : "border-slate-300 bg-white text-navy"}`} data-testid="proof-chip">
    <ShieldCheck className="h-4 w-4 text-flame" /> 30 years · Licensed & Insured · 1-Year Warranty
  </p>
);

export const ArrowLink = ({ to, children, dark = false, testId }) => (
  <Link to={to} data-testid={testId} className={`group inline-flex items-center gap-2 text-sm font-bold ${dark ? "text-white" : "text-navy"}`}>
    <span className="border-b-2 border-flame pb-0.5">{children}</span>
    <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
  </Link>
);

// Clipped photo frame with slow zoom on hover.
export const Frame = ({ src, alt, className = "", imgClass = "" }) => (
  <div className={`group relative overflow-hidden bg-navy ${className}`}>
    <img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.04] ${imgClass}`} />
  </div>
);
